// import Logo from 'assets/images/LogoIcon.svg';
import Logo from 'assets/images/LogoIconAndTextHorizontal.svg';


export const Initiation = () => {
    return (
        <section
            id="changeColor1"
            className="width-full-screen center-inside"
            style={{
                height: '100vh',
            }}
        >
            <div
                id="changeColor2"
                className="center-inside"
                style={{ borderRadius: 100, width: 200, height: 160 }}
            >
                <img alt="" src={Logo} />
            </div>
        </section>
    );
};
